import { render } from "./FormsGroupsByFamilyComponent.vue?vue&type=template&id=4877b655&scoped=true"
import script from "./FormsGroupsByFamilyComponent.vue?vue&type=script&lang=js"
export * from "./FormsGroupsByFamilyComponent.vue?vue&type=script&lang=js"

import "./FormsGroupsByFamilyComponent.vue?vue&type=style&index=0&id=4877b655&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4877b655"]])

export default __exports__